import { useState } from 'react';
import * as style from '../utils/general_style';
import * as links from '../utils/general_links';
import { questionsAnswers } from '../utils/question_faq';
import Response from '../components/faq/Response.jsx';
import CTAButton from '../components/global/CTAButton';

function Faq() {
    const [clicked, setClicked] = useState('0');

    const handleToggle = (index) => {
        if (clicked === index) {
            return setClicked('0');
        }
        setClicked(index);
    };

	return (
        <div className='AppBody'>
            <section style={style.ELEMENT_BLOCK_WHITE}>
                <h2>Foire aux questions</h2>
                {questionsAnswers.map(({ question, answer}, index) => (
                    <Response question={ question } answer={ answer } key={index} onToggle={() => handleToggle(index)} isActive={clicked === index} />
                ))}
                <div style={style.COLUMN_CENTER}>
                    <hr style={{width: '50%', margin: `${style.SPACE.medium} 0`}} color={style.COLORS.grey} size={'1'} />
                    <p style={{marginBottom: style.SPACE.medium}}>Un autre renseignement ?</p>
                    <CTAButton label='Demande de contact' route={links.ROUTES.contact} />
                </div>
            </section>
        </div>
	);
};

export default Faq;